import React from 'react';

// eslint-disable-next-line no-restricted-imports
import { forTemplate } from 'common/lib/util/i18n';
const l = forTemplate('home');

import styles from './team-cards-due-empty.less';

const partyTaco = require('images/home/cards/party-taco.svg');

export const Empty: React.FunctionComponent = () => (
  <div className={styles.empty}>{l('no-cards-due')}</div>
);

export const EmptyToday: React.FunctionComponent = () => (
  <div className={styles.emptyToday}>
    <img src={partyTaco} alt="" role="presentation" className={styles.image} />
    <div className={styles.title}>{l('due-today-empty')}</div>
    <div className={styles.subtitle}>{l('due-today-empty-subtitle')}</div>
  </div>
);



// WEBPACK FOOTER //
// ./app/scripts/views/home/presentational/team-cards-due-empty.tsx